import { render, staticRenderFns } from "./TokenManage.vue?vue&type=template&id=e3fc22b2&"
import script from "./TokenManage.vue?vue&type=script&lang=ts&"
export * from "./TokenManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports